import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "relative z-50",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_4 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_5 = { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6" }
const _hoisted_6 = { class: "sm:flex sm:justify-center" }
const _hoisted_7 = { class: "mt-3 sm:mt-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-medium leading-6 text-dark-blue" }, "Sure you want to decline?", -1)
const _hoisted_9 = { class: "mt-3 mb-4" }
const _hoisted_10 = { class: "text-sm text-[#989B9E]" }
const _hoisted_11 = { class: "mt-5 sm:mt-4 sm:flex sm:justify-center gap-x-4" }

import Button from "../../../AQuarks/Button.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignDeclineModal',
  props: {
  name: {
    type: String,
    required: true,
    default: false
  },
},
  emits: ['toggle-decline-modal', 'decline-campaign'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, "Are you sure you want to decline " + _toDisplayString(__props.name) + "?", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(Button, {
              buttonText: "No, Cancel",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-decline-modal'))),
              class: "text-dark-blue border border-dark-blue py-2.5 px-4 bg-transparent rounded shadow-md"
            }),
            _createVNode(Button, {
              buttonText: "Yes, Decline",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('decline-campaign'))),
              class: "text-white bg-orange-red py-2.5 px-4 rounded shadow-md"
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})